import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export const getOccupationSuggestions = async (occupation: string, lang: string, limit: number) => {
  try {
    const response = await API_V1.get('/linkedin/lookups/occupations', {
      params: {
        q: occupation,
        language: lang,
        limit,
      },
    });

    return response.data;
  } catch (e) {
    Logger.trace('Error while getting occupation suggestions!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const createOccupation = async (name: string, projectIds: string[]) => {
  try {
    const response = await API_V1.post('/linkedin/lookups/occupations', { occupation: name, projectIds });
    return response.data;
  } catch (e) {
    Logger.trace('Error while creating a new occupation');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e) };
  }
};
